module.exports = __webpack_public_path__ + "static/media/creditCard-band.df23c687.svg";